module.exports = __webpack_public_path__ + "static/header-strip-mobile-833e6a53450533d82b205837dbf67552.png";